import React from 'react';
// Using UserMd as a proxy for a doctor icon if available, or generic User
export function DoctorComment({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="my-8 bg-[#F0F4F8] border-l-4 border-[#2B4C7E] p-6 rounded-r-lg shadow-sm" data-id="element-271">
      <div className="flex items-center gap-2 mb-3 text-[#2B4C7E] font-bold font-sans uppercase text-sm tracking-wide" data-id="element-272">
        <img src="https://cdn.magicpatterns.com/uploads/pKikHmhQ6ydyrYtpPJUG5r/ЛИППЕРТ.jpg" alt="Dr. Lippert" className="w-8 h-8 rounded-full object-cover border border-[#2B4C7E]" data-id="element-273" />
        <span data-id="element-274">Dr. Lippert</span>
      </div>
      <div className="text-[#1B1B2F] text-lg leading-relaxed" data-id="element-275">{children}</div>
    </div>;
}